/**
 * Cross-cutting product constants. Keep values here (not scattered through
 * api/panel code) so ARCHITECTURE-mandated invariants have one home.
 */
/** Session token lifetimes (opaque bearer tokens; refresh rotates on use). */
export const AUTH_TOKEN_TTL = {
    accessMinutes: 15,
    refreshDays: 7,
};
/**
 * Public proposal / sub-invite tokens are 256-bit random values. Only the
 * SHA-256 hex of the raw token is ever stored (`token_hash`); the raw token
 * exists only inside the tokenized link.
 */
export const PUBLIC_TOKEN_BYTES = 32;
/**
 * ONE estimate numbering scheme, product-wide: `E-YYYYMMDD-NNN`.
 * The sequence is per company per date_key and grows past 999 naturally
 * (E-20260722-1000).
 */
export const ESTIMATE_NUMBER_REGEX = /^E-\d{8}-\d{3,}$/;
/** Build the `YYYYMMDD` date key for estimate numbering (local time). */
export function estimateDateKey(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}${m}${d}`;
}
/** Format an estimate number from a `YYYYMMDD` date key and a 1-based sequence. */
export function formatEstimateNumber(dateKey, sequence) {
    if (!/^\d{8}$/.test(dateKey)) {
        throw new TypeError(`formatEstimateNumber: invalid dateKey "${dateKey}" (expected YYYYMMDD)`);
    }
    if (!Number.isInteger(sequence) || sequence < 1) {
        throw new TypeError(`formatEstimateNumber: invalid sequence ${sequence} (expected integer >= 1)`);
    }
    return `E-${dateKey}-${String(sequence).padStart(3, '0')}`;
}
//# sourceMappingURL=constants.js.map